import { render, staticRenderFns } from "./wallet-admin.vue?vue&type=template&id=60150f9b&"
import script from "./wallet-admin.vue?vue&type=script&lang=js&"
export * from "./wallet-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports